import { useParams } from "react-router-dom"

export const useProjectCode = () => {
  const { projectCode } = useParams();
  return projectCode ? projectCode : 'NFT';
}